import { render, staticRenderFns } from "./overdueList.vue?vue&type=template&id=6961d121&scoped=true"
import script from "./overdueList.vue?vue&type=script&lang=js"
export * from "./overdueList.vue?vue&type=script&lang=js"
import style0 from "./overdueList.vue?vue&type=style&index=0&id=6961d121&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6961d121",
  null
  
)

export default component.exports